<template>
  <section class="page-not-found">
    <van-empty image="network" description="页面不存在" />
  </section>
</template>

<script>
export default {
  name: 'PageNotFound'
};
</script>

<style lang="scss" scoped>
</style>
